<template>
  <div
    class="bl-input-component w-full"
    :class="opened ? 'bl-input-component-active' : ''"
    @click="opened = true"
  >
    <label class="bl-input-label" :for="id">{{ activeLabel }}</label>
    <BlBubbleCount
      v-if="bubbleCount && masterCount"
      :count="masterCount"
      minified
      :style="{ zIndex: '1' }"
    />
    <input type="text" class="bl-input" :id="id" disabled />
    <div class="bl-input-border"></div>
    <BlIcon
      class="bl-input-icon ml-auto"
      icon="chevron-down"
      :style="opened ? 'rotate: 180deg' : ''"
    />
    <div v-if="opened" class="bl-input-dropdown" :data-id="id">
      <div
        class="bl-input-dropdown-header"
        :class="hasTabs ? '' : 'py-1'"
        :data-id="id"
      >
        <BlTextSubtitle2
          :text="hasTabs ? 'Filter by' : labelByTab"
          :data-id="id"
        />
        <BlInputButton
          label="Clear all"
          type="plain"
          :data-id="id"
          @clicked="onClearAll"
        />
        <div v-if="hasTabs" class="bl-input-dropdown-tabs" :data-id="id">
          <div
            v-for="item in input.tabs"
            :key="item.name || item"
            class="bl-input-dropdown-tab"
            :class="tab === item ? 'bl-input-dropdown-tab-active' : ''"
            @click.prevent="tab = item"
            :data-id="id"
          >
            <BlTextBody1 class="capitalize" :text="item.name || item" />
            <BlBubbleCount
              v-if="item.kind === 'date' ? date : input.model[item.kind].length"
              :count="
                item.kind === 'date'
                  ? date
                    ? 1
                    : 0
                  : input.model[item.kind].length
              "
              :type="tab === item ? 'primary' : 'secondary'"
              minified
            />
          </div>
        </div>
      </div>
      <div
        v-if="tab.kind === 'date'"
        class="bl-input-dropdown-body"
        :data-id="id"
      >
        <div
          class="bl-input-dropdown-option"
          :data-id="id"
          @click="date = 'last_week'"
        >
          <BlInputRadio
            :checked="date === 'last_week'"
            :data-id="id"
            name="date"
          />
          <span class="bl-input-dropdown-option-name" :data-id="id">
            Last 7 days
          </span>
        </div>
        <div
          class="bl-input-dropdown-option"
          :data-id="id"
          @click="date = 'last_month'"
        >
          <BlInputRadio
            :checked="date === 'last_month'"
            :data-id="id"
            name="date"
          />
          <span class="bl-input-dropdown-option-name" :data-id="id">
            Last 30 days
          </span>
        </div>
        <div
          class="bl-input-dropdown-option"
          :data-id="id"
          @click="date = 'last_year'"
        >
          <BlInputRadio
            :checked="date === 'last_year'"
            :data-id="id"
            name="date"
          />
          <span class="bl-input-dropdown-option-name" :data-id="id">
            Last 365 days
          </span>
        </div>
        <div
          class="bl-input-dropdown-option"
          :data-id="id"
          @click="date = 'custom'"
        >
          <BlInputRadio
            :checked="date === 'custom'"
            :data-id="id"
            name="date"
          />
          <span class="bl-input-dropdown-option-name" :data-id="id"
            >Custom</span
          >
        </div>
        <div class="bl-input-dropdown-date-wrapper" :data-id="id">
          <BlInputDate
            class="bl-input-dropdown-date"
            :input="startDateInput"
            :data-id="id"
            @changed="inputHandler"
            disabledManualInput
          />
          <div class="bl-input-dropdown-date-divider"></div>
          <BlInputDate
            class="bl-input-dropdown-date"
            :input="endDateInput"
            :data-id="id"
            @changed="inputHandler"
            disabledManualInput
          />
        </div>
      </div>
      <!-- v-if="tab.kind === 'therapist'" -->
      <div v-else class="bl-input-dropdown-body" :data-id="id">
        <div class="bl-input-dropdown-date-wrapper flex-grow" :data-id="id">
          <BlInputSearch
            class="flex-grow"
            :input="searchInput"
            @changed="inputHandler"
          />
        </div>
        <div class="max-h-44 overflow-y-auto">
          <div
            v-for="option in filteredOptions(searchInput.model, tab.options)"
            class="bl-input-dropdown-option"
            :key="option.value"
            :data-id="id"
            @click="valueHandler(option.value, tab.kind)"
          >
            <BlInputCheck
              :checked="
                value[tab.kind] ? value[tab.kind].includes(option.value) : false
              "
              :data-id="id"
            />
            <BlChip v-if="option.chip" :chip="option.value" />
            <span v-else class="bl-input-dropdown-option-name" :data-id="id">
              {{ option.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BlBubbleCount from "./BlBubbleCount.vue";
import BlIcon from "./BlIcon.vue";
import BlInputButton from "./BlInputButton.vue";
import BlInputDate from "./BlInputDate.vue";
import BlInputCheck from "./BlInputCheck.vue";
import BlInputRadio from "./BlInputRadio.vue";
import BlTextBody1 from "./BlTextBody1.vue";
import BlTextSubtitle2 from "./BlTextSubtitle2.vue";
import BlInputSearch from "./BlInputSearch.vue";
import BlChip from "./BlChip.vue";

export default {
  name: "BlInputFilterAdvance",
  components: {
    BlIcon,
    BlTextSubtitle2,
    BlInputCheck,
    BlInputButton,
    BlInputDate,
    BlTextBody1,
    BlBubbleCount,
    BlInputRadio,
    BlInputSearch,
    BlChip
  },
  props: {
    activeLabel: {
      type: String,
      default: "Filter by"
    },
    bubbleCount: {
      type: Boolean,
      default: false
    },
    input: {
      disabled: {
        type: Boolean,
        required: false
      },
      model: {
        type: Object,
        required: true
      },
      options: {
        type: Object,
        required: true
      },
      tabs: {
        type: Object,
        default: () => ["date"],
        required: false
      }
    }
  },
  data() {
    return {
      value: {},
      opened: false,
      tab: "date",
      date: null,
      startDateInput: {
        model: "",
        disabled: true,
        id: ""
      },
      endDateInput: {
        model: "",
        disabled: true,
        id: ""
      },
      searchInput: {
        model: "",
        placeholder: "Search ...",
        id: ""
      }
    };
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-input-filter-${combination}`;
    },
    masterCount() {
      const keys = Object.keys(this.input.model);
      let count = 0;
      keys.forEach(key => {
        if (key === "date") {
          if (this.input.model[key]) {
            count += 1;
          }
        } else {
          count += this.input.model[key] ? this.input.model[key].length : 0;
        }
      });
      return count;
    },
    startDate() {
      return this.startDateInput.model;
    },
    endDate() {
      return this.endDateInput.model;
    },
    hasTabs() {
      return this.input.tabs && this.input.tabs.length > 1;
    },
    labelByTab() {
      return this.input.tabs ? this.input.tabs[0].name : "Date";
    }
  },
  watch: {
    opened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      } else {
        this.onChange();
      }
    },
    date(val) {
      this.startDateInput.disabled = false;
      this.endDateInput.disabled = false;
      if (val !== "custom") {
        const range = val.replace("last_", "");
        this.startDateInput = {
          model: moment()
            .subtract(1, range)
            .format("YYYY-MM-DD"),
          disabled: true,
          id: this.id
        };
        this.endDateInput = {
          model: moment().format("YYYY-MM-DD"),
          disabled: true,
          id: this.id
        };
      }
    },
    input: {
      deep: true,
      handler(val) {
        this.generateValue(val);
      }
    }
  },
  mounted() {
    this.startDateInput.id = this.id;
    this.endDateInput.id = this.id;
    this.searchInput.id = this.id;
    this.generateValue(this.input);
    this.tab = this.input.tabs[0];
  },
  methods: {
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    generateValue(val) {
      if (val.model) {
        this.value = val.model;
        if (val.model.date) {
          const date = val.model.date;
          if (date.start_date && date.end_date) {
            this.date = "custom";
            this.startDateInput.disabled = false;
            this.endDateInput.disabled = false;
            this.startDateInput = {
              model: date.start_date,
              disabled: false,
              id: this.id
            };
            this.endDateInput = {
              model: date.end_date,
              disabled: false,
              id: this.id
            };
          } else {
            this.date = date;
          }
        }
      }
    },
    filteredOptions(query = "", options = []) {
      if (query) {
        return options.filter(i => {
          const value = i.value.toString().toLocaleLowerCase() || "";
          const name = i.name.toString().toLocaleLowerCase() || "";
          const key = query.toLocaleLowerCase();
          return value.includes(key) || name.includes(key);
        });
      } else return options;
    },
    valueHandler(val, tab) {
      const index = this.value[tab].findIndex(a => a === val);
      if (index > -1) {
        this.value[tab].splice(index, 1);
      } else {
        this.value[tab].push(val);
      }
      this.startDateInput.disabled = false;
      this.endDateInput.disabled = false;
      this.startDateInput = { model: "", disabled: true, id: this.id };
      this.endDateInput = { model: "", disabled: true, id: this.id };
    },
    onClearAll() {
      this.date = null;
      const keys = Object.keys(this.input.model);
      keys.forEach(key => {
        if (key === "date") {
          this.value.date = null;
          this.startDateInput = {
            model: "",
            disabled: true,
            id: this.id
          };
          this.endDateInput = {
            model: "",
            disabled: true,
            id: this.id
          };
        } else {
          this.value[key] = [];
        }
      });
    },
    onChange() {
      const value = {};
      const keys = Object.keys(this.input.model);
      keys.forEach(key => {
        if (key === "date") {
          value.date =
            this.date === "custom"
              ? { start_date: this.startDate, end_date: this.endDate }
              : this.date;
        } else {
          value[key] = this.value[key];
        }
      });
      this.$emit("changed", { input: this.input, value });
    },
    closeHandler(e) {
      let close = true;
      if (e.target && e.target.dataset && e.target.dataset.id) {
        const id = e.target.dataset.id || "";
        if (id === this.id) close = false;
      }
      if (close) {
        window.removeEventListener("click", this.closeHandler);
        this.opened = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.bl-input-component {
  position: relative;
  height: 2.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.bl-input-component label.bl-input-label {
  pointer-events: none;
  position: relative;
  z-index: 2;
  padding: 0 0 0 1rem;
  box-sizing: border-box;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: calc(11 / 7);
  color: var(--font-secondary-color);
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bl-input-component input.bl-input {
  z-index: -1;
  pointer-events: none;
  position: absolute;
  width: auto;
  padding: 0 1rem 0 0.5rem;
  opacity: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: calc(11 / 7);
  letter-spacing: 0.5px;
  box-sizing: border-box;
  display: flex;
  flex: 1;
}
.bl-input-component.bl-input-component-active .bl-input-border {
  border-color: var(--primary-color);
}
.bl-input-component .bl-input-tags {
  cursor: pointer;
  z-index: 2;
  position: relative;
  width: 100%;
  height: 2.5rem;
  padding: 0 2rem 0 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow-x: auto;
}
.bl-input-component .bl-input-border {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2.5rem;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid var(--border-color);
  background: var(--background-depth-one-color);
  z-index: 0;
}
.bl-input-component .bl-input-icon {
  cursor: pointer;
  position: relative;
  width: 1rem;
  height: 1rem;
  margin: 0 1rem 0 0.5rem;
}
.bl-input-component .bl-input-dropdown {
  z-index: 99;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 24rem;
  width: 100%;
  margin-top: 0.5rem;
  background: var(--background-depth-one-color);
  border-radius: 5px;
  border: 1px solid var(--border-color);
  box-shadow: 0 0.5rem 1rem rgba(100, 100, 100, 0.05);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.bl-input-component .bl-input-dropdown .bl-input-dropdown-header {
  position: relative;
  width: 100%;
  padding: 1rem 1rem 0 1rem;
  border-bottom: 1px solid var(--border-color);
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-header
  .bl-input-dropdown-tabs {
  position: relative;
  left: -1rem;
  width: calc(100% + 2rem);
  margin-top: 0.5rem;
  display: flex;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-header
  .bl-input-dropdown-tabs
  .bl-input-dropdown-tab {
  cursor: pointer;
  position: relative;
  padding: 0 1rem 0.5rem 1rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-header
  .bl-input-dropdown-tabs
  .bl-input-dropdown-tab
  * {
  pointer-events: none;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-header
  .bl-input-dropdown-tabs
  .bl-input-dropdown-tab.bl-input-dropdown-tab-active::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.25rem;
  background: var(--primary-color);
}
.bl-input-component .bl-input-dropdown .bl-input-dropdown-body {
  position: relative;
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-option {
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 2.5rem;
  display: flex;
  gap: 0.75rem;
  align-items: center;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-option
  * {
  pointer-events: none;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-option
  .bl-input-dropdown-option-name {
  pointer-events: none;
  position: relative;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: calc(5 / 3);
  letter-spacing: 0.5px;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-option
  .bl-input-dropdown-option-tag {
  pointer-events: none;
  position: relative;
  height: 1.5rem;
  padding: 0 0.5rem;
  border-radius: 0.75rem;
  box-sizing: border-box;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: calc(5 / 3);
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-date-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-date-wrapper
  .bl-input-dropdown-date {
  position: relative;
  width: calc((100% - 1.25rem) / 2);
}
.bl-input-component
  .bl-input-dropdown
  .bl-input-dropdown-body
  .bl-input-dropdown-date-wrapper
  .bl-input-dropdown-date-divider {
  position: relative;
  width: 0.75rem;
  height: 0.125rem;
  background: var(--font-secondary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputFilterAdvance.vue